// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../cache-deps/virtual-store/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#golive-radio .active[data-v-55da7262]{--tw-bg-opacity:1;background-color:rgba(97,78,196,var(--tw-bg-opacity));--tw-text-opacity:1;color:rgba(255,255,255,var(--tw-text-opacity))}", ""]);
// Exports
module.exports = exports;
